<template>
  <VCharts
    v-if="renderChart"
    ref="chartRef"
    :option="options"
    :auto-resize="autoResize"
    :style="{ width, height }"
  />
</template>

<script lang="ts" setup>
  import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue';
  import VCharts from 'vue-echarts';
  import debounce from 'lodash/debounce';
  // import { useAppStore } from '@/store';

  defineProps({
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
  });

  const chartRef = ref();

  // const appStore = useAppStore();
  // const theme = computed(() => {
  //   if (appStore.theme === 'dark') return 'dark';
  //   return '';
  // });
  const renderChart = ref(false);
  // wait container expand
  nextTick(() => {
    renderChart.value = true;
  });

  const onResize = debounce(() => {
    chartRef.value?.resize();
  }, 200);

  onMounted(() => {
    window.addEventListener('resize', onResize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize);
  });
</script>

<style scoped lang="less"></style>
